var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEduprocontracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 626.99 208.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6871f;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #004b68;\n      }\n\n      .cls-3 {\n        fill: #38a3d1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.34,
    cy: 34.45,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 102.68,
    cy: 34.45,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 172.02,
    cy: 34.45,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 241.36,
    cy: 34.45,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.71,
    cy: 34.45,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.34,
    cy: 103.79,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 102.68,
    cy: 103.79,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 172.02,
    cy: 103.79,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 241.36,
    cy: 103.79,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.67,
    cy: 173.13,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 104.01,
    cy: 173.13,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 173.36,
    cy: 173.13,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 242.7,
    cy: 173.13,
    r: 33.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.71,
    cy: 103.79,
    r: 33.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.47,156.24h-27.31c-4.32,0-6.48-3.04-6.48-9.11V9.11c0-6.07,2.16-9.1,6.48-9.11h27.31v21.59h-16.33c-.94,0-1.41.72-1.41,2.17v43h17.74v20.8h-17.74v45.14c0,1.46.47,2.18,1.41,2.18h16.33v21.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M452.78,132.48c0,15.84-4.32,23.76-12.95,23.76h-15.63c-8.67,0-13-7.92-13-23.76V63.17c0-15.84,4.33-23.76,13-23.76h13.23V0h15.35v132.48ZM434.04,135.84c2.26,0,3.38-2.11,3.38-6.33V59.8h-7.6c-2.16,0-3.24,2.12-3.24,6.34v63.37c0,4.22,1.08,6.33,3.24,6.33h4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500.51,147.72c0,5.68-2.07,8.52-6.2,8.52h-22.38c-8.67,0-13-7.92-13-23.76V39.41h15.35v90.1c0,4.22,1.08,6.33,3.24,6.33h6.52c.75,0,1.12-.66,1.12-2V39.41h15.35v108.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.75,156.24h-16V9.11c0-6.07,2.11-9.1,6.34-9.11h22.38c9.2,0,13.8,8.52,13.8,25.55v45c0,16.9-4.6,25.35-13.8,25.34h-12.72v60.35ZM530.36,75.24c2.34,0,3.52-2.44,3.52-7.33V28.91c0-4.88-1.18-7.32-3.52-7.32h-6.2c-.94,0-1.41.72-1.41,2.17v51.49h7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M570.04,156.24h-15.33V47.92c0-5.67,2.02-8.51,6.06-8.51h21.27v20.39h-10.85c-.76,0-1.13.67-1.13,2l-.02,94.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M626.94,132.48c0,15.84-4.32,23.76-12.95,23.76h-15.63c-8.67,0-13-7.92-13-23.76V63.17c0-15.84,4.33-23.76,13-23.76h15.68c8.63,0,12.94,7.92,12.95,23.76l-.05,69.31ZM608.22,135.84c2.25,0,3.38-2.11,3.38-6.33v-63.4c0-4.22-1.13-6.34-3.38-6.34h-4.18c-2.16,0-3.24,2.12-3.24,6.34v63.4c0,4.22,1.08,6.33,3.24,6.33h4.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.68,193.03c0-8.44,5.81-15.02,14.81-15.02,4.73,0,8.88,1.9,12.28,5.75l-4.35,4.55c-1.95-2.44-4.56-3.81-7.47-3.81-4.77,0-7.96,3.52-7.96,8.53s3.19,8.52,8.09,8.52c3.28,0,5.93-1.45,7.96-4.01l4.35,4.55c-3.24,4.14-7.92,5.96-12.77,5.96-9.04,0-14.93-6.37-14.93-15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.47,193.03c0-8.69,6.55-15.02,15.47-15.02s15.47,6.33,15.47,15.02-6.47,15.02-15.47,15.02-15.47-6.33-15.47-15.02ZM415.94,201.56c4.81,0,8.21-3.52,8.21-8.52s-3.4-8.53-8.21-8.53-8.17,3.52-8.17,8.53,3.4,8.52,8.17,8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.93,178.55h5.77l12.94,17.13v-17.13h6.84v28.97h-5.81l-12.9-17.09v17.09h-6.84v-28.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.79,185.09h-8.42v-6.54h24.01v6.54h-8.46v22.43h-7.13v-22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M493.28,178.55h12.19c6.72,0,11.12,3.93,11.12,9.81,0,4.14-1.99,7.2-5.52,8.73l6.43,10.43h-7.76l-5.47-9.35h-3.86v9.35h-7.13v-28.97ZM504.77,192.78c3.03,0,4.69-1.53,4.69-4.18s-1.66-4.22-4.69-4.22h-4.48v8.4h4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.32,178.55h7.63l11.12,28.97h-7.34l-1.82-5.05h-11.53l-1.82,5.05h-7.47l11.24-28.97ZM538.36,197.34l-4.19-11.55-4.27,11.55h8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.44,193.03c0-8.44,5.81-15.02,14.81-15.02,4.73,0,8.88,1.9,12.28,5.75l-4.35,4.55c-1.95-2.44-4.56-3.81-7.47-3.81-4.77,0-7.96,3.52-7.96,8.53s3.19,8.52,8.09,8.52c3.28,0,5.93-1.45,7.96-4.01l4.35,4.55c-3.24,4.14-7.92,5.96-12.77,5.96-9.04,0-14.93-6.37-14.93-15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.8,185.09h-8.42v-6.54h24.01v6.54h-8.46v22.43h-7.13v-22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M603.31,204l3.07-5.13c2.86,1.99,5.72,2.94,8.88,2.94,2.9,0,4.56-.91,4.56-2.52s-1.53-2.48-5.89-3.68c-6.39-1.7-9.41-4.39-9.41-9.1s3.94-8.32,10.66-8.32c4.19,0,8.05,1.32,11.07,3.56l-3.11,4.97c-1.99-1.53-5.02-2.57-7.71-2.57-2.36,0-3.86.87-3.86,2.28s1.2,2.28,5.52,3.52c6.76,1.86,9.91,4.68,9.91,9.31,0,5.17-4.6,8.65-11.57,8.65-4.48,0-8.83-1.41-12.11-3.89Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduprocontracts);
export default __webpack_public_path__ + "static/media/eduprocontracts.483defcc55a25b46ffbb2864baecff13.svg";
export { ForwardRef as ReactComponent };